import { LandingTemplate } from "@/components/LandingTemplate";
import { IMG, FAQS } from "@/data/site";

const faqs = FAQS.filter((f) => f.c === "Universities" || f.c === "Pool" || f.c === "Restaurants");

export default function FamilyTravel() {
  return (
    <LandingTemplate
      seo={{
        title: "Family Hotel in Ottawa, KS — Indoor Pool & Free Breakfast",
        description: "A family-friendly hotel in Ottawa, Kansas with a year-round indoor pool, free breakfast and free WiFi. Perfect for family vacations, college visits, sports tournaments, reunions and weekend trips near KU, Ottawa University and Baker University.",
        path: "/family-travel",
        breadcrumbs: [{ name: "Home", path: "/" }, { name: "Family Travel", path: "/family-travel" }],
        faqs,
      }}
      kicker="Made for Families"
      heroTitle="Family Travel"
      heroLines={["Space to", "make memories", "together"]}
      heroImage={IMG.poolKids}
      intro="Family trips are easier when the hotel does its part. Two-queen family rooms, a heated indoor pool the kids will beg to use, free breakfast to start the day and free parking out front — all at a price that leaves room in the budget for the fun stuff."
      audiences={["Family vacations", "College visits", "Sports tournaments", "Family reunions", "Weekend trips", "Holiday travel", "Wedding guests", "Graduations"]}
      features={[
        { icon: "Waves", title: "Indoor Pool", desc: "A heated, year-round pool that keeps kids happy in any weather." },
        { icon: "Coffee", title: "Free Breakfast", desc: "Waffles, cereal, fruit and more — feed the whole family free." },
        { icon: "BedDouble", title: "Double Queen Rooms", desc: "Comfortable two-queen rooms with space for everyone." },
        { icon: "GraduationCap", title: "Near 3 Universities", desc: "Close to Ottawa University, and an easy drive to KU and Baker." },
        { icon: "Wifi", title: "Free WiFi", desc: "Keep the kids entertained and stay connected." },
        { icon: "Utensils", title: "Dining Nearby", desc: "Restaurants within walking distance for easy family meals." },
      ]}
      bandImage={IMG.pool}
      bandTitle="A basecamp for the whole crew"
      bandText="Whether you're touring campuses, cheering at a tournament or gathering the family for a reunion, we make the logistics simple — so you can spend your energy on the people you came with, not the planning."
      benefits={[
        "Heated indoor pool for the kids",
        "Free family breakfast every morning",
        "Double queen family rooms",
        "Close to KU, Ottawa University & Baker University",
        "Free parking & free WiFi",
        "Affordable rates that fit the family budget",
      ]}
      keywords={["Family hotel Ottawa KS", "Hotel near Ottawa University", "Hotel near University of Kansas", "Hotel near Baker University", "Family hotel with pool Kansas", "Hotel for sports tournaments Ottawa"]}
      faqs={faqs}
    />
  );
}
